
export const state = () => ({
})

export const getters = {
}

export const mutations = {
}

export const actions = {

  async checkDocument({ commit }, image, documentType) {
    return await this.$api.idValidator.checkDocument(image, documentType);
  },

  async convertImg2PDF({ commit }, pdfFile) {
    return await this.$api.idValidator.convertImg2PDF(pdfFile);
  },
  

}
